<template>
  <v-app>
    <component v-if = "layout" :is="layout">
      <transition name="slide" mode="out-in">
        <router-view/>
      </transition>
    </component>
    <transition v-else name="slide" mode="out-in">
        <router-view/>
    </transition>

     <chat-plugin
       v-show="!['/publish', '/chat-history-new', '/' , '/login', '/sign-up'].includes($router.currentRoute.path)"
     />

  </v-app>
</template>

<script>
const default_layout = 'default'
import chatPlugin from "./components/chatPlugin/chatPlugin";
export default {
  name: 'App',
  components:{
    chatPlugin
  },
  data () {
    return {
      //
    }
  },
  mounted() {
    // console.log(this.$router.currentRoute )
    this.$router.afterEach(()=>{
      this.$root.$emit('route-changed')
    })
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    // Listen to message from child window
    eventer(messageEvent,function(e) {
      if (e && e.data === 'toggleWidget') {

        document.getElementsByClassName('widget-iframe-wrapper')[0].classList.toggle('widget-test-active')
      }

    },false);

  },
  computed: {
    layout() {
      if (!this.$route.meta.layout) return undefined
      return this.$route.meta.layout+ '-layout' 
    },
    botId () {
      return this.$store.state.bot.botId
    }
  }
}
</script>

<style lang="scss">
  

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-Italic.eot');
    src: local('Cera Pro Italic'), local('CeraPro-Italic'),
    url('./assets/fonts/CeraPro-Italic.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-Italic.woff') format('woff'),
    url('./assets/fonts/CeraPro-Italic.ttf') format('truetype');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: 'Cera-Pro-Regular';
    src: url('./assets/fonts/CeraPro-Regular.eot');
    src: local('Cera Pro Regular'), local('CeraPro-Regular'),
    url('./assets/fonts/CeraPro-Regular.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-Regular.woff') format('woff'),
    url('./assets/fonts/CeraPro-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-BlackItalic.eot');
    src: local('Cera Pro Black Italic'), local('CeraPro-BlackItalic'),
    url('./assets/fonts/CeraPro-BlackItalic.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-BlackItalic.woff') format('woff'),
    url('./assets/fonts/CeraPro-BlackItalic.ttf') format('truetype');
    font-weight: 900;
    font-style: italic;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-Light.eot');
    src: local('Cera Pro Light'), local('CeraPro-Light'),
    url('./assets/fonts/CeraPro-Light.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-Light.woff') format('woff'),
    url('./assets/fonts/CeraPro-Light.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-BoldItalic.eot');
    src: local('Cera Pro Bold Italic'), local('CeraPro-BoldItalic'),
    url('./assets/fonts/CeraPro-BoldItalic.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-BoldItalic.woff') format('woff'),
    url('./assets/fonts/CeraPro-BoldItalic.ttf') format('truetype');
    font-weight: bold;
    font-style: italic;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-Black.eot');
    src: local('Cera Pro Black'), local('CeraPro-Black'),
    url('./assets/fonts/CeraPro-Black.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-Black.woff') format('woff'),
    url('./assets/fonts/CeraPro-Black.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-Medium.eot');
    src: local('Cera Pro Medium'), local('CeraPro-Medium'),
    url('./assets/fonts/CeraPro-Medium.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-Medium.woff') format('woff'),
    url('./assets/fonts/CeraPro-Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-Bold.eot');
    src: local('Cera Pro Bold'), local('CeraPro-Bold'),
    url('./assets/fonts/CeraPro-Bold.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-Bold.woff') format('woff'),
    url('./assets/fonts/CeraPro-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-Thin.eot');
    src: local('Cera Pro Thin'), local('CeraPro-Thin'),
    url('./assets/fonts/CeraPro-Thin.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-Thin.woff') format('woff'),
    url('./assets/fonts/CeraPro-Thin.ttf') format('truetype');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-MediumItalic.eot');
    src: local('Cera Pro Medium Italic'), local('CeraPro-MediumItalic'),
    url('./assets/fonts/CeraPro-MediumItalic.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-MediumItalic.woff') format('woff'),
    url('./assets/fonts/CeraPro-MediumItalic.ttf') format('truetype');
    font-weight: 500;
    font-style: italic;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-LightItalic.eot');
    src: local('Cera Pro Light Italic'), local('CeraPro-LightItalic'),
    url('./assets/fonts/CeraPro-LightItalic.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-LightItalic.woff') format('woff'),
    url('./assets/fonts/CeraPro-LightItalic.ttf') format('truetype');
    font-weight: 300;
    font-style: italic;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('./assets/fonts/CeraPro-ThinItalic.eot');
    src: local('Cera Pro Thin Italic'), local('CeraPro-ThinItalic'),
    url('./assets/fonts/CeraPro-ThinItalic.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/CeraPro-ThinItalic.woff') format('woff'),
    url('./assets/fonts/CeraPro-ThinItalic.ttf') format('truetype');
    font-weight: 100;
    font-style: italic;
  }
  @font-face {
    font-family: "GT-Walsheim-Pro-Regular";
    src: url("./assets/fonts/GT-Walsheim-Pro-Regular.ttf");
  }



  @import "./assets/sass/variables";
  @import "./assets/sass/buttons";
  @import "./assets/sass/cards";
  @import "./assets/sass/inputs";
  @import "./assets/sass/text";
  @import "./assets/sass/layout";
  @import "./assets/sass/commponents/header-toolbar";
  @import "./assets/sass/commponents/sidebar";
  @import "./assets/sass/commponents/rules";
  @import "./assets/sass/commponents/blocks-build";
  @import "./assets/sass/commponents/blocks";
  @import "./assets/sass/commponents/add.block.buttons";
  @import "./assets/sass/commponents/image-uploader";
  @import "./assets/sass/commponents/login";
  @import "./assets/sass/commponents/chat-preview";
  @import "./assets/icons/botter-dashboard-icons-v1.0/style.css";
  @import "./assets/css/animate.css";
  @import "./assets/css/grid.css";
  @import "./assets/sass/commponents/sub-sidebar";
  @import "./assets/sass/commponents/chat-history";
  @import "./assets/sass/commponents/widgetBody";
  @import "./assets/sass/trumps";
  @import "./assets/sass/commponents/campaginsOverview";
  @import "./assets/sass/commponents/chatHistory";
  @import "./assets/sass/helpers";
  .slide-enter-active{
    animation: slide-in 500ms ease-out forwards;
  }

  .slide-leave-active{
    animation: slide-out 500ms ease-out forwards;
  }
  @keyframes slide-in {
    from{
      transform: translateY(-30px);
      opacity:0;
    }
    to{
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide-out {
    from{
      transform: translateY(0);
      opacity:1;
    }
    to{
      transform: translateY(-30px);
      opacity: 0;
    }
  }
  .widget-iframe-wrapper {
    position: fixed;
    right: 0;
    height: 80px;
    bottom: 0;
    z-index: 1000;
  }
  .widget-test-active {
    height: 70%;
  }
</style>
